import React, { useEffect, useImperativeHandle } from 'react';
import getEnv from '../../../../../services/util/getEnv';

const PartnerStack = React.forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    onSignup (name, email, customerKey) {
      onSignup(name, email, customerKey);
    }
  }));

  const injectPartnerStack = () => {
    var gs = document.createElement('script');
    gs.src = 'https://js.partnerstack.com/v1/';
    gs.type = 'text/javascript';
    gs.async = 'true';
    gs.onload = gs.onreadystatechange = function () {
      var rs = this.readyState;
      if (rs && rs !== 'complete' && rs !== 'loaded') return;
      try {
        growsumo._initialize(getEnv("REACT_APP_PARTNERSTACK_KEY"));
        if (typeof growsumoInit === 'function') {
          growsumoInit();
        }
      } catch (e) {}
    };
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(gs, s);

    return gs;
  };

  const removePartnerStack = (script) => {
    script.remove();
  };

  const onSignup = (name, email, customerKey) => {
    if (growsumo) {
      growsumo.data.name = name;
      growsumo.data.email = email;
      growsumo.data.customer_key = customerKey;

      // Register the signup with PartnerStack
      growsumo.createSignup();
    }
  };

  useEffect(() => {
    const psScript = injectPartnerStack();

    return () => {
      removePartnerStack(psScript);
    };
  }, []);

  return <></>;
});

export default PartnerStack;
